import {Component, Input, OnInit} from '@angular/core';
import {ArticleFamilyConstants} from "../../../constants/articles-family.constants";

@Component({
  selector: 'app-request-flow-info-box',
  templateUrl: './request-flow-info-box.component.html',
  styleUrls: ['./request-flow-info-box.component.scss']
})
export class RequestFlowInfoBoxComponent implements OnInit {

  @Input() minimizedReview: boolean;

  ArticleFamilyConstants = ArticleFamilyConstants;

  @Input() data: any;
  @Input() offersSelected?: any;

  constructor() {
  }

  ngOnInit(): void {
  }

}
